var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgThreeDotsBlack = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2.8,
    height: 14,
    viewBox: "0 0 2.8 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "overflow-menu-vertical",
    transform: "translate(-15.75 -6.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M18.55,8.15a1.4,1.4,0,1,1-1.4-1.4A1.4,1.4,0,0,1,18.55,8.15Z",
    transform: "translate(0)",
    fill: "#0d3148"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M18.55,17.15a1.4,1.4,0,1,1-1.4-1.4A1.4,1.4,0,0,1,18.55,17.15Z",
    transform: "translate(0 -3.4)",
    fill: "#0d3148"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M18.55,26.15a1.4,1.4,0,1,1-1.4-1.4A1.4,1.4,0,0,1,18.55,26.15Z",
    transform: "translate(0 -6.8)",
    fill: "#0d3148"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgThreeDotsBlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/three_dots_black.3c6c6e6dce5be6a7adcf01b4530e4164.svg";